import React from 'react';
import { DATA_LINK, WEB_PROXY } from '../formats';
import CopyButton from '../utils/CopyButton';
import fromReactElementToCopyable from '../utils/fromReactElementToCopyable';
import fromReactElementToString from '../utils/fromReactElementToString';
import DefaultFormatDataLink from './DefaultFormatDataLink';
import DefaultFormatWebProxyLink from './DefaultFormatWebProxyLink';

const DefaultTypeString = props => {
  const {
    data,
    schema,
    path = [],
    enableCopyField,
    customCopyFieldComponent,
  } = props;

  const copyableText = fromReactElementToCopyable(data);

  if (schema.format && schema.format === DATA_LINK) {
    return <DefaultFormatDataLink {...props} />;
  }

  if (schema.format && schema.format === WEB_PROXY) {
    return <DefaultFormatWebProxyLink {...props} />;
  }

  return (
    <div className={`default-type-string depth-${path.length}`}>
      <strong className="default-type-string-title">{schema.title}</strong>{' '}
      {schema.format === 'audio-url' && <br />}
      <span className="default-type-string-value">
        {fromReactElementToString(data)}
      </span>
      {enableCopyField && (
        <CopyButton
          text={copyableText}
          customButton={customCopyFieldComponent}
        />
      )}
    </div>
  );
};

export default DefaultTypeString;
